import script from '/workspace/build/DistributionPackages/Dsr.SeebadDe/Resources/Private/Fusion/Presentation/Composite/SiteHeader/SiteHeader.ts';

export const prototypeName = 'Dsr.SeebadDe:Composite.SiteHeader';
export {script};